import React from 'react';
const ToastContext = React.createContext(null);
export default ToastContext;
